import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';

const Header = ({ tag }) => {
  const { hero } = useContext(PortfolioContext);
  const { subTitle } = hero;

  return (
    <section id="hero" className="jumbotron">
      <Container>
        <h1 className="hero-title">
          {`こちらは【${tag}】というタグが付けられた音楽の一覧ページとなります`}
          <br />
          <span className="text-color-main">{subTitle}</span>
        </h1>
        <p className="hero-cta">
          <span className="cta-btn cta-btn--hero">
            <Link to="projects" smooth duration={1000}>
              音楽を聴いてみる
            </Link>
          </span>
        </p>
        <p className="hero-cta">
          <span className="cta-btn cta-btn--hero">
            <a href="/">TOPに戻る</a>
          </span>
        </p>
      </Container>
    </section>
  );
};

Header.propTypes = {
  tag: PropTypes.string,
};

export default Header;
